<template>
    <div>
      <v-footer app v-if="initialOidcUserLoaded" color="#002B49" :height="64" :key="currentStep">
          <p>&copy; {{ new Date().getFullYear() }} Amwins, Inc. All Rights Reserved. | <a href="https://www.amwins.com/privacy" target="_blank">Privacy</a></p>
          <v-spacer></v-spacer>
          <div class="help-links">
            <span>
              <a :href="helpCenterHome"
                 target="_blank"
                 rel="noopener noreferrer"
                 aria-label="Help Center (opens in a new tab)"
                 data-testid="footerHelpCenter">
                <i class="fas fa-circle-question"></i>&nbsp;&nbsp;Help Center
              </a>
            </span>
            <span style="cursor: pointer;" class="intercom_button">
              <i class="fas fa-comment-alt-lines"></i>&nbsp;&nbsp;Chat
            </span>
            <span>
              <a href="mailto:digital.customerservice@amwins.com">
                <i class="fas fa-envelope"></i>&nbsp;&nbsp;Email
              </a>
            </span>
            <span>
              <a href="tel:+14047514400">
                <i class="fas fa-phone"></i>&nbsp;&nbsp;404-751-4400
              </a>
            </span>
            <span>
              <a href="#" @click="$store.dispatch('logout')">
                Logout
              </a>
            </span>
          </div>
      </v-footer>
      <HelpCenterBubble :intercomEnabled="true" :showHelpIcon="showHelpIcon" />
    </div>
</template>

<script>
import HelpCenterBubble from '@/components/ui/HelpCenterBubble.vue';
import { HELP_CENTER_HOME } from '@/scripts/help-center';

export default {
    name: 'TheFooter',
    components: {
      HelpCenterBubble
    },
    data () {
      return {
          routeName: null,
          currentStep: null,
          showHelpIcon: false,
          helpCenterHome: HELP_CENTER_HOME
      };
    },
    computed: {
      initialOidcUserLoaded () {
          return this.$store.getters.getUser && this.$route.path !== '/callback';
      }
    },
    methods: {
      setupWatcher () {
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (this.initialOidcUserLoaded) {
                    this.showHelpIcon = !entry.isIntersecting;
                }
            });
        });
        let footer = document.querySelector('.footer-wrapper');
        if (footer) {
            this.observer.observe(footer);
        }
      }
    },
    watch: {
      '$store.state.currentStep': function () {
          this.currentStep = this.$store.state.currentStep;
      }
    },
    created () {
      this.routeName = this.$router.currentRoute.name;

      this.$router.afterEach((to) => {
          this.routeName = to.name;
      });
    },
    mounted () {
      this.setupWatcher();
    },
    beforeUnmount () {
      let footer = document.querySelector('.footer-wrapper');
      if (footer) {
      this.observer.unobserve(footer);
    }
  }
};
</script>

<style scoped lang="scss">
.v-footer {
    padding: 0 40px;
    z-index: 499;
    * {
        color: white;
    }
    p {
        font-size: 12px;
        margin-bottom: 0;
        a {
            text-decoration: none;
        }
    }
    .help-links {
        span {
            font-size: 15px;
            padding: 0 8px;
            display: inline-block;
            white-space: nowrap;
        }
        a {
            text-decoration: none;
        }
    }
}
</style>

